<!-- =========================================================================================
  File Name: addSidebarView.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4 style="word-break: normal;">
        {{ Object.entries(this.data).length === 0 ? "ADD NEW" : "EDIT" }} CAMERA
      </h4>
      <feather-icon
        icon="XIcon"
        @click.stop="isSidebarActiveLocal = false"
        class="cursor-pointer"
      ></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component
      :is="scrollbarTag"
      class="scroll-area--data-list-add-new"
      :settings="settings"
      :key="$vs.rtl"
    >
      <div class="p-6">
        <!-- NAME -->
        <vs-input
          maxlength="50"
          label="Camera Name *"
          v-model="cameraName"
          class="mt-5 w-full"
          name="camera_name"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('camera_name')">{{
          errors.first("camera_name")
        }}</span>

        <!-- CAMERA CODE -->
        <vs-input
          label="Camera code *"
          v-model="cameraCode"
            maxlength="50"
          class="mt-5 w-full"
          name="camera_code"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('camera_code')">{{
          errors.first("camera_code")
        }}</span>
        <!-- CAMERA ID -->
        <vs-input
          label="Camera ID *"
          v-model="cameraId"
            maxlength="50"
          class="mt-5 w-full"
          name="camera_id"
        />
        <!-- LOCATION -->
        <br />
         <!-- <label class="vs-select--label w-full">Select Room</label>
        <v-select  label="name"   :closeOnSelect="true" v-model="dataRoom"  :options="rooms"  /><br> -->
        
         <label class="vs-select--label w-full">Select Groups</label>
        <v-select  label="name" multiple :closeOnSelect="true" v-model="dataGroup"  :options="groups"  /><br>
        <vs-row class="mb-5 ml-1">
          <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="6">
            <label>Status</label>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="flex-end"
            vs-align="center"
            vs-w="6"
          >
            <vs-switch v-model="dataStatus"></vs-switch>
          </vs-col>
        </vs-row>
        <!-- <label>Locations</label><br />
        <ul class="centerx mt-2 flex flex-wrap">
          <li class="ml-1" v-for="location in locations" :key="location.id">
            <vs-radio v-model="dataLocation" :vs-value="location.id">{{
              location.name
            }}</vs-radio>
          </li>
        </ul>
        <span v-if="locations.length < 1" class="text-danger text-sm"
          >Please Add Location First!</span
        >
        <br /> -->
          <label>Select Color *</label><br />
        <!--        <v-select    multiple :closeOnSelect="false" v-model="selected" :options="options" :dir="$vs.rtl ? 'rtl' : 'ltr'" /> <br>-->
        <!-- EMAIL CONFIRMED STATUS -->
        <ul class="centerx mt-2 flex flex-wrap">
          <li class="ml-1" v-for="(color, index) in suggestcolors" :key="index">
         <vs-radio class="color_radio" :color="color"
          :style="{backgroundColor:color}" style="border-style:none" v-model="customPrimaryColor" :vs-value="color">{{
            }}</vs-radio>
          </li>
        </ul>
        <br />
        <!-- COLOR PICKER -->
        <div>
          <label class="mb-4" v-if="customPrimaryColor">Selected Color</label><br v-if="colorCheck > 0" />
          <span class="text-danger text-sm" v-if="colorCheck > 0"
            >This color is already taken. Please select a different color for
            this camera.</span
          >
          <ul class="clearfix">
            <!-- Custom Color Square -->
            <li
              :style="{ backgroundColor: customPrimaryColor }"
              :class="{ 'shadow-outline': customPrimaryColor == primaryColor }"
              class="w-10 cursor-pointer h-10 rounded-lg m-2 float-left"
            />
            <!-- <li class="float-left">
              <input
                class="w-10 cursor-pointer h-10 rounded-lg m-2"
                @input="checkcolor(customPrimaryColor, dataId)"
                v-model="customPrimaryColor"
                type="color"
                name="color_code"
              />
            </li> -->
          </ul>
        </div>
      </div>
      <div class="flex items-center justify-between px-6">
        <h5>SCHEDULE</h5>
        <!-- <h4>{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "UPDATE" }} SCHEDULE</h4> -->
      </div>
      <vs-divider class="mb-0"></vs-divider>
            <div class="flex ml-5 mt-5">
          <vs-checkbox v-model="LocationBox" >Assign Location Schedule</vs-checkbox>
        </div>
         <div v-if="LocationBox" class="p-6 pt-0">
             <div
          class="slot-fields"
          v-for="(date, index) in locationSchedule"
          :key="index"
        >
          <br />{{ index }}
          <div
            class="slot-fields"
            v-for="(item, dayindex) in date"
            :key="dayindex"
          >
            <small style="color: red">{{
              getTime(index, dayindex, item.start_time, item.end_time)
            }}</small>
            <vs-row>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="6"
              >
                <flat-pickr
                  v-model="item.start_time"
                  :config="configdateTimePicker"
                  class="timepicker"
                  name="start_time"
                  placeholder="Start time"
                />
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="6"
              >
                <flat-pickr
                  v-model="item.end_time"
                  :config="configdateTimePicker"
                  class="timepicker"
                  name="end_time"
                  placeholder="End time"
                />
                  <span
                  class="danger cursor-pointer"
                  @click="inputLocationRemove(index, dayindex)"
                  style="color: red"
                  >x</span>
              </vs-col>
              <!-- <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="2"
              >
                <span
                  class="danger ml-2"
                  @click="inputLocationRemove(index, dayindex)"
                  style="color: red"
                  >x</span
                >
              </vs-col> -->
            </vs-row>
            <!-- <flat-pickr v-model="item.start_time" :config="configdateTimePicker" class="picker" name="start_time" placeholder="Start time"/>
    <flat-pickr v-model="item.end_time" :config="configdateTimePicker" class="picker" name="end_time" placeholder="End time"/>
    <span class="danger" @click="inputRemove(index,dayindex)" style="color:red">x</span> -->
          </div>
          <div class="slot-actions pr-2 mt-1" style="float:right;clear: both">
            <vs-button color="primary" size="small" @click.native="inputLocationAdd(index)"
              ><feather-icon icon="PlusIcon" svgClasses="h-2 w-2"
            /></vs-button>
          </div>
        </div>
         <span>
          <p v-for="(scheduledate, index) in locationSchedule" :key="index"  class="product-name font-medium truncate" >
             {{scheduledate.day}}   {{scheduledate.start_time}} {{scheduledate.end_time}}
          </p>
       </span>
        </div>
      <div v-else>
        <!-- NAME -->
        <!-- <vs-row class="pl-5 pr-10 pb-0">
     <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
           <vs-input label="Schedule Name"  v-model="currrent_schedule.name" class="mt-5 w-full" name="item-name" v-validate="'required'"/>
        <span class="text-danger text-sm" v-show="errors.has('item-name')">{{ errors.first('item-name') }}</span>
     </vs-col>
</vs-row> -->
        <div
          class="slot-fields p-6 pt-0"
          v-for="(date, index) in currrent_schedule.dates"
          :key="index"
        >
          <br />{{ index }}
          <div
            class="slot-fields"
            v-for="(item, dayindex) in date"
            :key="dayindex"
          >
            <small style="color: red">{{
              getTime(index, dayindex, item.start_time, item.end_time)
            }}</small>
            <vs-row>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="6"
              >
                <flat-pickr
                  v-model="item.start_time"
                  :config="configdateTimePicker"
                  class="timepicker"
                  name="start_time"
                  placeholder="Start time"
                />
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="6"
              >
                <flat-pickr
                  v-model="item.end_time"
                  :config="configdateTimePicker"
                  class="timepicker"
                  name="end_time"
                  placeholder="End time"
                />
                <span
                  class="danger cursor-pointer"
                  @click="inputRemove(index, dayindex)"
                  style="color: red"
                  >x</span
                >
              </vs-col>
            </vs-row>
          </div>
          <div class="slot-actions pr-2 mt-1" style="float:right;clear: both">
            <vs-button color="primary" size="small" @click.native="inputAdd(index)"
              ><feather-icon icon="PlusIcon" svgClasses="h-2 w-2"
            /></vs-button>
          </div>
        </div>
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click.native="submitData" :disabled="!isFormValid"
        >Submit</vs-button
      >
      <vs-button
        type="border"
        color="danger"
        @click="isSidebarActiveLocal = false"
        >Cancel</vs-button
      >
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {
  ALL_LOCATIONS,
  CREATE_CAMERA,
  UPDATE_CAMERA,
  CAMERA_COLOR
} from '@/graphql'
import Datepicker from 'vuejs-datepicker'
import vSelect from 'vue-select'
import moment from 'moment'
import moduleDataList from '@/store/data-list/moduleDataList.js'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { CREATE_SCHEDULE, UPDATE_SCHEDULE, ALL_SCHEDULE, SUGGEST_COLOR, UPDATE_CAMERA_With_SCHEDULE_IN_LOCATION, ALL_ROOMS, ROOM_BY_LOCATION,GROUP_BY_LOCATION} from '@/graphql'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect,
    Datepicker,
    flatPickr,
    moment
  },
  data () {
    return {
      LocationBox:false,
      locationSchedule:'',
      locations: [],
      dataId: null,
      cameraName: '',
      cameraCode: '',
      dataLocation: '',
      dataStatus: false,
      customPrimaryColor: '',
      cameraId: '',
      colorCheck: 0,
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      },
      dataSibling: '',
      dataSchedule: [],
      current_schedule_dates: '',
      oldSchedule: '',
      previewSchedule: '',
      currrent_schedule: {
        id: '',
        name: '',
        dates: {
          Monday: [
            {
              start_time: '',
              end_time: ''
            }
          ],
          Tuesday: [
            {
              start_time: '',
              end_time: ''
            }
          ],
          Wednesday: [
            {
              start_time: '',
              end_time: ''
            }
          ],
          Thursday: [
            {
              start_time: '',
              end_time: ''
            }
          ],
          Friday: [
            {
              start_time: '',
              end_time: ''
            }
          ],
          Saturday: [
            {
              start_time: '',
              end_time: ''
            }
          ],
          Sunday: [
            {
              start_time: '',
              end_time: ''
            }
          ]
        }
      },
      ex_current_schedule: {
        dates: {
          Monday: [],
          Tuesday: [],
          Wednesday: [],
          Thursday: [],
          Friday: [],
          Saturday: [],
          Sunday: []
        }
      },
      configdateTimePicker: {
        enableTime: true,
        noCalendar: true,
        timeFormat: 'H:i',
        time_24hr: false,
        altInput: true,
        dateFormat: 'H:i'
      },
      camera_name: '',
      camera_id: '',
      schedules: [],
      deletedschedules: [],
      suggestcolors:[],
      rooms:[],
      dataRoom:null,
      groups:[],
      dataGroup:null
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.getcolor(this.dataId)
        // this.checkcolor(this.customPrimaryColor, this.dataId);
        this.initValues()
        this.$validator.reset()
      } else {
        const {
          id,
          name,
          code,
          location,
          color_code,
          camera_id,
          schedule,
          status,
          room,
          groups
        } = JSON.parse(JSON.stringify(this.data))
        this.getRooms(location.id)
        this.getGroups(location.id)
        this.locationSchedule = {
          Monday: [],
          Tuesday: [],
          Wednesday: [],
          Thursday: [],
          Friday: [],
          Saturday: [],
          Sunday: []
        }
        for (let index = 0; index < location.schedule.scheduledates.length; index++) {
          delete location.schedule.scheduledates[index].__typename
          delete location.schedule.scheduledates[index].id
        }
        for (let i = 0; i < location.schedule.scheduledates.length; i++) {
          var day = location.schedule.scheduledates[i].day
          if (day == 'Monday') {
            this.locationSchedule.Monday.push(location.schedule.scheduledates[i])
          }
          if (day == 'Tuesday') {
            this.locationSchedule.Tuesday.push(location.schedule.scheduledates[i])
          }
          if (day == 'Wednesday') {
            this.locationSchedule.Wednesday.push(location.schedule.scheduledates[i])
          }
          if (day == 'Thursday') {
            this.locationSchedule.Thursday.push(location.schedule.scheduledates[i])
          }
          if (day == 'Friday') {
            this.locationSchedule.Friday.push(location.schedule.scheduledates[i])
          }
          if (day == 'Saturday') {
            this.locationSchedule.Saturday.push(location.schedule.scheduledates[i])
          }
          if (day == 'Sunday') {
            this.locationSchedule.Sunday.push(location.schedule.scheduledates[i])
          }
        }
        // this.checkcolor(color_code, id);
        this.getcolor(id)
        this.dataId = id
        this.cameraName = name
        this.cameraCode = code
        this.dataStatus = status
        this.dataLocation = location.id
        if (room) {
          this.dataRoom = room
        } else {
          this.dataRoom = null
        }
        this.dataGroup=groups
        this.cameraId = camera_id
        this.customPrimaryColor = color_code
        this.currrent_schedule.id = schedule.id
        this.currrent_schedule.name = schedule.name
        this.currrent_schedule.dates = {
          Monday: [],
          Tuesday: [],
          Wednesday: [],
          Thursday: [],
          Friday: [],
          Saturday: [],
          Sunday: []
        }
        const getarry = []
        for (let i = 0; i < schedule.scheduledates.length; i++) {
          delete schedule.scheduledates[i].id
          delete schedule.scheduledates[i].__typename
          getarry.push(schedule.scheduledates[i])
        }
        for (let i = 0; i < getarry.length; i++) {
          var day = getarry[i].day
          if (day == 'Monday') {
            this.currrent_schedule.dates.Monday.push(getarry[i])
          }
          if (day == 'Tuesday') {
            this.currrent_schedule.dates.Tuesday.push(getarry[i])
          }
          if (day == 'Wednesday') {
            this.currrent_schedule.dates.Wednesday.push(getarry[i])
          }
          if (day == 'Thursday') {
            this.currrent_schedule.dates.Thursday.push(getarry[i])
          }
          if (day == 'Friday') {
            this.currrent_schedule.dates.Friday.push(getarry[i])
          }
          if (day == 'Saturday') {
            this.currrent_schedule.dates.Saturday.push(getarry[i])
          }
          if (day == 'Sunday') {
            this.currrent_schedule.dates.Sunday.push(getarry[i])
          }
        }

        this.initValues()
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },
  computed: {
    primaryColor: {
      get () {
        return this.$store.state.themePrimaryColor
      },
      set (val) {
        this.$store.commit('UPDATE_PRIMARY_COLOR', val)
      }
    },
    // locations () {
    //   return this.$store.state.dataList.locations
    // },
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
          this.colorCheck = 0
        }
      }
    },
    isFormValid () {
      this.currrent_schedule.name =
        `${'Camera' + ' '}${  this.cameraName  } ` + 'Schedule'
      return (
        !this.errors.any() &&
        this.cameraName &&
        this.cameraCode &&
        this.dataLocation &&
        this.colorCheck == 0 &&
        this.currrent_schedule.name &&
        this.customPrimaryColor
      )
    },
    scrollbarTag () {
      return this.$store.getters.scrollbarTag
    }
  },
  methods: {
    getTime (day, index, start_time, end_time) {
      const space = '  '
      if (start_time.toString() != '' && end_time.toString() != '') {
        if (end_time > start_time) {
          return ''
        } else {
          return (
            `End Time is Less than Start Time at ${  day  }${space  }${index + 1}`
          )
        }
      }
    },
    inputLocationAdd (dayindex) {
      const index = this.locationSchedule[dayindex].length
      this.locationSchedule[dayindex].push({
        start_time: '',
        end_time: ''
      })
    },
    inputLocationRemove (index, dayindex) {
      if (this.locationSchedule[index][dayindex].id) {
        this.deletedschedules.push(
          this.locationSchedule[index][dayindex].id
        )
      }
      this.locationSchedule[index].splice(dayindex, 1)
    },
    inputAdd (dayindex) {
      const index = this.currrent_schedule.dates[dayindex].length
      this.currrent_schedule.dates[dayindex].push({
        start_time: '',
        end_time: ''
      })
    },
    inputRemove (index, dayindex) {
      if (this.currrent_schedule.dates[index][dayindex].id) {
        this.deletedschedules.push(
          this.currrent_schedule.dates[index][dayindex].id
        )
      }
      this.currrent_schedule.dates[index].splice(dayindex, 1)
    },
    initValues () {
      this.LocationBox = false,
      this.previewSchedule = '',
      this.locationSchedule = '',

      this.currrent_schedule = {
        id: '',
        name: '',
        dates: {
          Monday: [
            {
              start_time: '',
              end_time: ''
            }
          ],
          Tuesday: [
            {
              start_time: '',
              end_time: ''
            }
          ],
          Wednesday: [
            {
              start_time: '',
              end_time: ''
            }
          ],
          Thursday: [
            {
              start_time: '',
              end_time: ''
            }
          ],
          Friday: [
            {
              start_time: '',
              end_time: ''
            }
          ],
          Saturday: [
            {
              start_time: '',
              end_time: ''
            }
          ],
          Sunday: [
            {
              start_time: '',
              end_time: ''
            }
          ]
        }
      },
      this.deletedschedules = []
      this.dataStatus = false
    },
    checkcolor (color, id) {
      this.$apollo
        .mutate({
          mutation: CAMERA_COLOR,
          variables: {
            id,
            color
          }
        })
        .then((response) => {
          if (response) {
            this.colorCheck = response.data.checkCameraColor.counter
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    StatusSuccess (item, action) {
      this.$emit('getdata', true)
      this.$vs.notify({
        title: 'Camera',
        text: `${item  } ${  action  } successfully`,
        color: 'success',
        position: 'top-right'
      })
    },
    StatusFail (item, action) {
      this.$vs.notify({
        title: 'Camera',
        text: `${item  } ${  action}`,
        color: 'danger',
        position: 'top-right'
      })
    },
    updatePrimaryColor (color) {
      this.primaryColor = color
      this.$vs.theme({ primary: color })
    },
    initValues () {
      if (this.data.id) return
      this.dataId = null
      this.cameraName = ''
      this.cameraCode = ''
      this.dataLocation = ''
      this.dataRoom = null
      this.cameraId = ''
      this.colorCheck = 0
      this.customPrimaryColor = '',
      this.currrent_schedule = {
        id: '',
        name: '',
        dates: {
          Monday: [
            {
              start_time: '',
              end_time: ''
            }
          ],
          Tuesday: [
            {
              start_time: '',
              end_time: ''
            }
          ],
          Wednesday: [
            {
              start_time: '',
              end_time: ''
            }
          ],
          Thursday: [
            {
              start_time: '',
              end_time: ''
            }
          ],
          Friday: [
            {
              start_time: '',
              end_time: ''
            }
          ],
          Saturday: [
            {
              start_time: '',
              end_time: ''
            }
          ],
          Sunday: [
            {
              start_time: '',
              end_time: ''
            }
          ]
        }
      }
    },
    submitData () {
      const finalschedule = []
      let error = 0
      if (this.LocationBox) {
        var dates = this.locationSchedule
      } else {
        var dates = this.currrent_schedule.dates
      }
      for (let i = 0; i < dates.Monday.length; i++) {
        var element = dates.Monday[i]
        if (element['start_time'] != '' && element['end_time'] != '') {
          element['day'] = 'Monday'
          finalschedule.push(element)
        }
      }
      for (let i = 0; i < dates.Tuesday.length; i++) {
        var element = dates.Tuesday[i]
        if (element['start_time'] != '' && element['end_time'] != '') {
          element['day'] = 'Tuesday'
          finalschedule.push(element)
        }
      }
      for (let i = 0; i < dates.Wednesday.length; i++) {
        var element = dates.Wednesday[i]
        if (element['start_time'] != '' && element['end_time'] != '') {
          element['day'] = 'Wednesday'
          finalschedule.push(element)
        }
      }
      for (let i = 0; i < dates.Thursday.length; i++) {
        var element = dates.Thursday[i]
        if (element['start_time'] != '' && element['end_time'] != '') {
          element['day'] = 'Thursday'
          finalschedule.push(element)
        }
      }
      for (let i = 0; i < dates.Friday.length; i++) {
        var element = dates.Friday[i]
        if (element['start_time'] != '' && element['end_time'] != '') {
          element['day'] = 'Friday'
          finalschedule.push(element)
        }
      }
      for (let i = 0; i < dates.Saturday.length; i++) {
        var element = dates.Saturday[i]
        if (element['start_time'] != '' && element['end_time'] != '') {
          element['day'] = 'Saturday'
          finalschedule.push(element)
        }
      }
      for (let i = 0; i < dates.Sunday.length; i++) {
        var element = dates.Sunday[i]
        if (element['start_time'] != '' && element['end_time'] != '') {
          element['day'] = 'Sunday'
          finalschedule.push(element)
        }
      }
      checkSchedule(finalschedule)
      function checkSchedule (finalschedule) {
        if (finalschedule.length > 0) {
          for (let i = 0; i < finalschedule.length; i++) {
            if (finalschedule[i].end_time <= finalschedule[i].start_time) {
              error++
            }
          }
        } else {
          error++
        }
      }
      this.$validator.validateAll().then((result) => {
        if (result && error == 0) {
          const locations = []
           var groups=[]
          let selectedRoom
          if (this.dataRoom) {
            selectedRoom = this.dataRoom.id
          } else {
            selectedRoom = ' '
          }
          if (this.dataGroup) {
             for (let index = 0; index < this.dataGroup.length; index++) {
                 var element = this.dataGroup[index]
                 groups.push(element.id)               
             }
          } 
          if (this.dataId !== null && this.dataId >= 0) {
            this.$apollo
              .mutate({
                mutation: UPDATE_CAMERA_With_SCHEDULE_IN_LOCATION,
                variables: {
                  id: this.dataId,
                  name: this.cameraName,
                  code: this.cameraCode,
                  color_code: this.customPrimaryColor,
                  camera_id: this.cameraId,
                  room_id:selectedRoom,
                  groups:groups,
                  location_id: this.dataLocation,
                  status:this.dataStatus,
                  schedule_name:this.currrent_schedule.name,
                  scheduledates: finalschedule
                }
              })
              .then(response => {
                if (response) {
                  this.StatusSuccess('Camera', 'Updated')
                  this.LocationBox = false
                  this.$emit('closeSidebar')
                  this.initValues()
                  this.$validator.reset()
                }
              }).catch(error => {
                this.StatusFail('Camera', 'Fail')

                console.log(error)
              })
            // this.$apollo
            //   .mutate({
            //     mutation: UPDATE_CAMERA,
            //     variables: {
            //       id: this.dataId,
            //       name: this.cameraName,
            //       code: this.cameraCode,
            //       color_code: this.customPrimaryColor,
            //       camera_id: this.cameraId,
            //       location_id: this.dataLocation,
            //       status: this.dataStatus,
            //     },
            //   })
            //   .then((response) => {
            //     if (response) {
            //       this.StatusSuccess("Camera", "Updated");
            //       this.$emit("closeSidebar");
            //       this.initValues();
            //     }
            //   })
            //   .catch((error) => {
            //     this.StatusFail("Camera", "Update Fail");
            //     console.log(error);
            //   });
            // if (result && error == 0) {
            //   if (
            //     this.currrent_schedule.id !== "" &&
            //     this.currrent_schedule.id >= 0
            //   ) {
            //     var newschedule = [];
            //     for (let i = 0; i < finalschedule.length; i++) {
            //       if (!finalschedule[i].id) {
            //         newschedule.push(finalschedule[i]);
            //       }
            //     }
            //     finalschedule = finalschedule.filter(function (item) {
            //       if (item.id) {
            //         return true;
            //       } else {
            //         return false;
            //       }
            //     });
            //     this.$apollo
            //       .mutate({
            //         mutation: UPDATE_SCHEDULE,
            //         variables: {
            //           id: this.currrent_schedule.id,
            //           name: this.currrent_schedule.name,
            //           scheduledates: {
            //             update: finalschedule,
            //             create: newschedule,
            //             delete: this.deletedschedules,
            //           },
            //         },
            //       })
            //       .then((response) => {
            //         if (response) {
            //           // this.StatusSuccess("Schedule","Updated")
            //           this.$emit("closeSidebar");
            //           this.initValues();
            //         }
            //       })
            //       .catch((error) => {
            //         this.StatusSuccess("Schedule", "Fail");
            //         console.log(error);
            //       });
            //   }
            // }
          } else {
            this.$apollo
              .mutate({
                mutation: CREATE_CAMERA,
                variables: {
                  name: this.cameraName,
                  code: this.cameraCode,
                  color_code: this.customPrimaryColor,
                  camera_id: this.cameraId,
                  location_id: this.dataLocation,
                  status: this.dataStatus
                }
              })
              .then((response) => {
                if (response) {
                  this.camera_id = response.data.createCamera.id
                  this.camera_name = response.data.createCamera.name


                  this.$apollo
                    .mutate({
                      mutation: CREATE_SCHEDULE,
                      variables: {
                        name: this.currrent_schedule.name,
                        scheduledates: {
                          create: finalschedule
                        }
                      }
                    })
                    .then((response) => {
                      if (response) {
                        // this.StatusSuccess("Schedule","Created")
                        this.$apollo
                          .mutate({
                            mutation: UPDATE_CAMERA,
                            variables: {
                              id: this.camera_id,
                              name: this.camera_name,
                              schedule_id: response.data.createSchedule.id
                            }
                          })
                          .then((response) => {
                            if (response) {
                              // this.StatusSuccess("Camera","Updated")
                              this.$emit('closeSidebar')
                              this.initValues()
                            }
                          })
                          .catch((error) => {
                            this.StatusFail('Camera', 'Update Fail')
                          })
                      }
                    })
                    .catch((error) => {
                      this.StatusFail('Schedule', 'Fail')
                    })


                  this.StatusSuccess('Camera', 'Created')
                }
              })
              .catch((error) => {
                // this.StatusFail("Camera","Fail")

                console.log(error)
              })

          }
        } else {
          this.StatusFail('Schedule is Required', 'Failed')
        }
      })
    },
    getcolor (id) {
      this.$apollo
        .mutate({
          mutation: SUGGEST_COLOR,
          variables: {
            id
          }
        })
        .then((response) => {
          this.suggestcolors = response.data.suggestcolors.colors
        })

    },
    getRooms (location) {
      this.$apollo
        .mutate({
          mutation: ROOM_BY_LOCATION,
          variables: {
            location
          }
        }).then(response => {
          this.rooms = response.data.roomsByLocation
        })
    },
      getGroups (location) {
      this.$apollo
        .mutate({
          mutation: GROUP_BY_LOCATION,
          variables: {
            location
          }
        }).then(response => {
          this.groups = response.data.groupsByLocation
        })
    }
  },

  created () {
    this.$apollo
      .mutate({
        mutation: ALL_LOCATIONS
      })
      .then((response) => {
        this.locations = response.data.locations
      })
    this.$apollo
      .mutate({
        mutation: ALL_SCHEDULE,
        variables: {
          status:1
        }
      })

      .then(response => {
        this.schedules = response.data.schedules
      })

    // this.$apollo
    //   .mutate({
    //     mutation: ALL_ROOMS
    //   })
    //   .then(response => {
    //     this.rooms = response.data.Rooms
    //   })
  }
  
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
  }
 .color_radio {
        height: 16px;
        width: 16px;
        border-radius: 10px;
        border-style:none;


  }

</style>
<style>
.timepicker{
  width: 100%;
}
</style>

